export const GET_SYSTEM_SETTINGS = 'GET_SYSTEM_SETTINGS';